<template>
	<div class="form">
        <h1>Lisandro<br/>Aristimuño</h1>

        <div v-if="!send">
            <h2>Descarga tu disco digital</h2>
            <form @submit.prevent="checkCode">
                <div class="inptu-container">
                    <label>Disco</label>
                    <div class="selectField">
                        <select v-model.lazy="$v.disco.$model">
                            <option :value="item.disco_mp3" v-for="(item, index) in discos" :key="item.index">{{item.nombre}} (.MP3)</option>
                            <option :value="item.disco_wav" v-for="(item, index) in discos" :key="item.index">{{item.nombre}} (.WAV)</option>
                        </select>
                    </div>
                    <span class="alert" v-if="$v.disco.$anyError && !$v.disco.required">Campo requerido</span>
                </div>

                <div class="inptu-container">
                    <label>Correo Electrónico</label>
                    <input type="email" v-model.lazy="$v.email.$model" :class="{'error' : $v.email.$error}"/>
                    <span class="alert" v-if="$v.email.$anyError && !$v.email.required">Campo requerido</span>
                    <span class="alert" v-if="$v.email.$anyError && !$v.email.email">Ingrese un email correcto</span>
                </div>

                <div class="inptu-container">
                    <label>Código de Descarga</label>
                    <input type="text" v-model.lazy="$v.codigo.$model" :class="{'error' : $v.codigo.$error}"/>
                    <span class="alert" v-if="$v.codigo.$anyError && !$v.codigo.required">Campo requerido</span>
                </div>

                <div class="inptu-container">
                    <label class="check">Acepto <a href="#">términos y condiciones</a>
                        <input type="checkbox">
                        <span class="checkmark"><i class="fas fa-check"></i></span>
                    </label>
                </div>

                <button type="submit" :disabled="!btn">
                    <i class="far fa-download"></i> Descargar
                </button>
            </form>
        </div>

        <div class="download" v-if="send">
            <img src="@/assets/images/email.png" class="center-block"/>
            <h1>¡Listo!</h1>
            <p>Revisa tu casilla de correo, te enviamos un email con tu link de descarga.</p>
        </div>

        <vodal :show="show" animation="rotate" @hide="show = false" :height="200" :width="350" >
            <div class="content">
                <div>{{modalError}}</div>
                <button class="vodal-confirm-btn" @click="show = false">Aceptar</button>
            </div>
        </vodal>

        <vodal :show="showDownload" animation="rotate" @hide="showDownload = false" :height="200" :width="350" >
            <div class="content">
                <div>Se envio un email con el enlace de descarga.</div>
                <button class="vodal-confirm-btn" @click="showDownload = false">Aceptar</button>
            </div>
        </vodal>
    </div>
</template>

<script>
    import axios from "axios"
    import Vodal from 'vodal';
    import { required, email } from 'vuelidate/lib/validators'

    import { mapState } from 'vuex'

    export default {
    	name: 'Form',
        components: {
            Vodal
        },
        data() {
            return {
                send: false,
                show: false,
                showDownload: false,
                disco: null,
                codigo: null,
                email: null,
                btn: true,
                modalError: '',
                discos: []
            }
        },
        computed: {
            ...mapState(['requests'])
        },
        methods: {
            async getDiscos() {
                let datos = await axios.get(this.requests.discos.endpoint, {params: this.requests.discos.playload})
                this.discos = datos.data.results
            },

            async checkCode(e) {
                this.$v.$touch()
                this.btn = false

                if (!this.$v.$invalid) {
                    var params = this.requests.check.playload

                    params.disco = this.disco
                    params.codigo = this.codigo
                    params.email = this.email

                    let datos = axios.get(this.requests.check.endpoint, {params: params}).then(res => {

                        if (res.data.code == '1') {
                            this.send = true
                        }

                        else {
                            this.modalError = res.data.message
                            this.show = true
                        }

                        this.disco = null
                        this.codigo = null
                        this.email = null

                        this.$v.$reset()
                    })
                }

                this.btn = true
            }
        },
        created () {
            this.getDiscos()
        },
        validations: {
            disco: { required },
            codigo: { required },
            email: { required , email}
        }
    }
</script>